import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ConnectedIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const ConnectedIcon = ({ strokeWidth, ...props }: ConnectedIconProps) => (
  <BaseIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    title="Connected Icon"
    strokeWidth={strokeWidth}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2ZM8 4C8 1.79086 9.79086 0 12 0C14.2091 0 16 1.79086 16 4C16 6.20914 14.2091 8 12 8C9.79086 8 8 6.20914 8 4Z"
      fill="#141B4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10ZM0 12C0 9.79086 1.79086 8 4 8C6.20914 8 8 9.79086 8 12C8 14.2091 6.20914 16 4 16C1.79086 16 0 14.2091 0 12Z"
      fill="#141B4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7072 6.70706L6.70718 10.7071L5.29297 9.29285L9.29297 5.29285L10.7072 6.70706Z"
      fill="#141B4D"
    />
  </BaseIcon>
);

ConnectedIcon.displayName = 'ConnectedIcon';
